"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isChildOfType = isChildOfType;
var _react = _interopRequireDefault(require("react"));
function isChildOfType(child, type) {
  if (typeof child === 'undefined' || child === null) return false;
  if (typeof child === 'string') {
    return type === 'text';
  }
  if (typeof child === 'number') {
    return type === 'number';
  }
  if ( /*#__PURE__*/_react.default.isValidElement(child)) {
    if (typeof type === 'string') {
      return child.type === type;
    }
    // React Hot Loader 会对组件进行代理。使用 createElement() 返回的 element.type 才是实际的类型
    // remark: https://github.com/gaearon/react-hot-loader/issues/304#issuecomment-223222772
    return child.type === /*#__PURE__*/_react.default.createElement(type, {}).type;
  }
  return false;
}